// extracted by mini-css-extract-plugin
module.exports = {"navButton":"TopRightButton_navButton__1Wwok"};